import { Divider } from 'antd';
import React, { FC, memo, useCallback } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { useAppDispatch } from 'app/config/storeConfig/hooks';
import { Box, useGetOfficesForBookingQuery } from 'entities/Box';
import { requestFormModalActions, RequestModalMode } from 'widgets/RequestModal';
import { OfficeCollapse } from 'features/OfficeCollapse';
import { Button } from 'shared/ui/Button';
import { useGetRentOptionsQuery } from 'entities/RentOption';

interface SelectOfficeContentProps {
  selectedBoxId: string | undefined;
  selectedWarehouseId: string | undefined;
  onSelectBox: (box: Box, sizeCodeId?: string) => void;
  onCompleteStep: (box: Box, sizeCodeId?: string) => void;
}

export const SelectOfficeContent: FC<SelectOfficeContentProps> = memo((props) => {
  const { selectedBoxId, selectedWarehouseId, onCompleteStep, onSelectBox } = props;

  const { t } = useAppTranslation('booking');
  const dispatch = useAppDispatch();

  const { data } = useGetOfficesForBookingQuery({ warehouseId: selectedWarehouseId, isAvailable: true }, { skip: !selectedWarehouseId });
  // TODO: Add unit type query param
  const { data: rentOptions } = useGetRentOptionsQuery({ warehouseId: selectedWarehouseId }, { skip: !selectedWarehouseId });

  const handleOpenRequestFormModal = useCallback((): void => {
    dispatch(
      requestFormModalActions.openRequestModal({
        title: t('Let`s get to know each other better!'),
        description: t('Please provide us with your information so that we can suggest the best pricing options that meet your needs.'),
        mode: RequestModalMode.REQUEST_OFFER,
      }),
    );
  }, [dispatch, t]);

  const handleOpenBookTourFormModal = useCallback((): void => {
    dispatch(
      requestFormModalActions.openRequestModal({
        mode: RequestModalMode.BOOK_TOUR,
      }),
    );
  }, [dispatch]);

  return (
    <div className="bg-secondaryLight rounded-lg">
      <OfficeCollapse
        offices={data}
        rentOptions={rentOptions}
        selectedBoxId={selectedBoxId}
        onSelectBox={onSelectBox}
        onBookBox={onCompleteStep}
      />
      <div className="mt-4 flex justify-center flex-wrap">
        <div className="flex items-center justify-end flex-col gap-3">
          <div className="flex items-center justify-end flex-col">
            <div>{t('Did not find what you were looking for?')}</div>
            <div className="flex w-full justify-between">
              <Button theme="clear" className="underline" fontSize="large" onClick={handleOpenRequestFormModal}>
                {t('Request an offer')}
              </Button>
              <Button onClick={handleOpenBookTourFormModal} theme="clear" className="underline" fontSize="large">
                {t('Book a tour')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
